// @flow
import { createFormReducer } from 'redux-pure-form';
import { omit } from 'lodash';

import type { Reducer } from 'redux';

import {
  EVENT_ADD,
  EVENT_VIEW,
  EVENT_DELETE,
  EVENT_CANCEL,
  EVENT_SAVE,
  EVENT_CHECKOUT,
  CANCEL_CHECKOUT,
  EVENT_CHECKIN,
  CANCEL_CHECKIN,
  MOVE_EVENT_START,
  MOVE_EVENT_FINISH,
  MOVE_EVENT
} from '../calendar/calendar.consts.js';

import { GET_INVOICES } from '../invoice/invoice.const.js';

const eventHandler: Reducer<$ElementType<ReduxState, 'event'>, Action> = createFormReducer(
  'event',
  {}
);
export function event(state: $ElementType<ReduxState, 'events'> = {}, action: Action) {
  switch (action.type) {
    case EVENT_VIEW:
      return action.payload;
    default:
      return eventHandler(state, action);
  }
}

export const events = (state: $ElementType<ReduxState, 'events'> = {}, action: Action) => {
  let updatedEvents;

  switch (action.type) {
    case GET_INVOICES:
      return {
        ...state,
        ...action.payload.events
      };

    case EVENT_ADD:
      const newEvents = action.payload.toDays.reduce(
        (acc, item) => ({
          ...acc,
          [item.event.id]: {
            ...(state[item.event.id] ? state[item.event.id] : {}),
            ...action.payload.event,
            ...item.event
          }
        }),
        {}
      );
      return {
        ...state,
        ...newEvents
      };

    case EVENT_SAVE:
    case MOVE_EVENT:
      updatedEvents = action.payload.toDays.reduce(
        (acc, item) => ({
          ...acc,
          [item.event.id]: {
            ...(state[item.event.id] ? state[item.event.id] : {}),
            ...action.payload.event,
            ...item.event
          }
        }),
        {}
      );
      return {
        ...state,
        ...updatedEvents
      };

    case EVENT_DELETE:
    case EVENT_CANCEL:
      const deletedEvents = action.payload.fromDays.map(item => item.event.id);
      updatedEvents = action.payload.toDays.reduce(
        (ac, item) => ({
          ...ac,
          [item.event.id]: {
            ...(state[item.event.id] ? state[item.event.id] : {}),
            ...state[item.event.id],
            ...item.event
          }
        }),
        {}
      );

      return {
        ...omit(state, deletedEvents),
        ...updatedEvents
      };

    case EVENT_CHECKOUT:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          inFlight: '1'
        }
      };

    case CANCEL_CHECKOUT:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          inFlight: '0'
        }
      };

    case EVENT_CHECKIN:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          inFlight: '0',
          completed: '1'
        }
      };

    case CANCEL_CHECKIN:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          completed: '0',
          inFlight: '1'
        }
      };
    case EVENT_VIEW:
      return {
        ...state,
        [action.payload.id]: action.payload
      };
    case MOVE_EVENT_START:
    case MOVE_EVENT_FINISH:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          startTime: action.payload.startTime,
          finishTime: action.payload.finishTime
        }
      };
    default:
      return state;
  }
};
